const traverseObjectMeshes = (object, callback) => {
	object.traverse((node) => {
		if (node.isMesh) {
			const materials = Array.isArray(node.material) ? node.material : [node.material];
			materials.forEach(callback);
		}
	});
};

export default traverseObjectMeshes;
